import React from 'react';
import { useTranslation } from 'react-i18next';
import { amountToUsd } from '@utils/currency';
import { InsurerLogo } from '@components/Feature/Insurer';
import { CancerQuote } from '@models/CancerQuote';

const CancerQuoteItem = ({ totalPremium, insurer }: CancerQuote) => {
  const { t } = useTranslation();

  return (
    <div className="d-flex flex-column align-items-center">
      <div className="d-flex justify-content-center align-items-center border bg-white p-1 rounded mb-1">
        <InsurerLogo insurer={insurer} fluid rounded />
      </div>
      <div>
        {t('cancerQuote.premium')}: <span className="text-primary">{amountToUsd(totalPremium)}</span>
      </div>
    </div>
  );
};

export { CancerQuoteItem };
